var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderNews'),_c('div',{staticClass:"news-content"},[_c('router-view')],1),(_vm.deviceType == 'PC')?_c('div',{staticClass:"footer_con"},[_c('Footer')],1):_c('div',{staticStyle:{"color":"#fff"}},[_c('FooterDom')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }